import { apiCall } from "../utils/ApiUtils";
import { getSession, setSessionJSON } from "../utils/SessionUtils";

const companyCode = getSession("COMPANY");

export const validateUser = async (username, password) => {
  const adminUrl = process.env.REACT_APP_ADMIN_BASE_URL;
  const url = `${adminUrl}/user/${companyCode}/validate/${username}/${password}`;

  try {
    const response = await apiCall("POST", url); // Use generic API call
    console.log("User validation response:", response);
    setSessionJSON("login-data", response); // Store user data in session
    return response; // Return the response data
  } catch (error) {
    throw new Error("Invalid username or password"); // Throw error for invalid user
  }
};


export const validateUserByEmail = async (email) => {
  const adminUrl = process.env.REACT_APP_ADMIN_BASE_URL;
  const url = `${adminUrl}/user/AVANTECH/validateByEmail/${email}`;

  try {
    const response = await apiCall("POST", url); // Use generic API call
    console.log("User validation response:", response);
    setSessionJSON("login-data", response); // Store user data in session
    return response; // Return the response data
  } catch (error) {
    throw new Error("Invalid username or password"); // Throw error for invalid user
  }
};

export const findAllParameters = async () => {
  const adminUrl = process.env.REACT_APP_ADMIN_BASE_URL;
  const url = `${adminUrl}/general/${companyCode}/findAllParameters`;

  try {
    const response = await apiCall("GET", url); // Use generic API call
    console.log("Find all parameters response:", response);
    setSessionJSON("parameters", response); // Store parameters data in session
    return response; // Return the response data
  } catch (error) {
    throw new Error("Failed to fetch parameters"); // Throw error for failure
  }
};


export const saveUser = async (userData) => {
  const adminUrl = process.env.REACT_APP_ADMIN_BASE_URL;
  const url = `${adminUrl}/user/${companyCode}/saveUser`;

  try {
    const response = await apiCall("POST", url, userData); // Use generic API call
    console.log("Save user response:", response);
     // Store user data in session
    return response; // Return the response data
  } catch (error) {
    throw new Error("Failed to save user"); // Throw error for failure
  }
};



